export function shouldInitGoogle(type) {
  return type === 'google'
}

export function shouldInitFacebook(type) {
  return type === 'facebook'
}

export function shouldInitApple(type) {
  return type === 'apple'
}
